module.exports = __webpack_public_path__ + "static/media/RI-D2-1.1-061.d6af69af.webp";